import { LeaderboardView } from '../../../../components/worldcup/LeaderboardView/LeaderboardView';
import { useCompetitionId } from '../../../../src/competitions/contexts/CompetitionContext';
import { useCompetitionSummary, competitionDisplayTitle } from '../../../../src/competitions/hooks/useCompetitionSummary';
import { COMPETITION_LEADERBOARD_MIN_SHOW_THRESHOLD } from '../../../../src/competitions/helpers/competitionLeaderboard.helper';

export default function CompetitionLeaderboardScreen() {
  const competitionId = useCompetitionId();
  const { competition } = useCompetitionSummary(competitionId);
  return (
    <LeaderboardView
      minShowThreshold={COMPETITION_LEADERBOARD_MIN_SHOW_THRESHOLD}
      competitionName={competitionDisplayTitle(competition) || undefined}
    />
  );
}
